export const skuIDInfo = () => {
  return (
    <>
      <div className="info-title">About SKUs</div>
      <div className="info-content">
        <div>Products include SKUs you can purchase. There are two types:</div>
        <ul>
          <li>
            <b>Fixed SKUs:</b> You pay a set monthly, weekly, or one time cost.
          </li>
          <li>
            <b>Variable SKUs:</b> You pay for what you actually use. For
            example, if you select 2 GB but use 10 GB in a month, you’ll be
            charged for 10 GB.
          </li>
        </ul>
      </div>
    </>
  );
};

export const unitCostInfo = () => {
  return (
    <>
      <div className="info-title">Unit cost</div>
      <div className="info-content">
        <div>
          Price you will pay for each unit you are ordering. These are the unit
          type of products:
          <ul>
            <li>GBs</li>
            <li>Hours</li>
            <li>Licences</li>
            <li>Instance</li>
            <li>Tokens</li>
            <li>Units</li>
            <li>
              One time - example would be setup fee to enable a product ready
              for use.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export const unitPerPeriodInfo = () => {
  return (
    <>
      <div className="info-title">Units per period</div>
      <div className="info-content">
        <div>
          This is the number of units you’ll request for each period. The period
          depends on the product and can be monthly, weekly, or one time.
        </div>
      </div>
    </>
  );
};

export const numberOfPeriodsInfo = () => {
  return (
    <>
      <div className="info-title">Number of periods</div>
      <div className="info-content">
        <div>
          This is the length of time you’re requesting the SKU. The period
          depends on the product and can be monthly, weekly, or one time.
        </div>
      </div>
    </>
  );
};

export const subTotalInfo = () => {
  return (
    <>
      <div className="info-title">Subtotal - Cost calculation overview</div>
      <div className="info-content">
        <div>Subtotal = Unit cost x Units per period x Number of periods</div>
      </div>
    </>
  );
};

export const totalCostInfo = () => {
  return (
    <>
      <div className="info-title">Total cost - Cost calculation overview</div>
      <div className="info-content">
        <div>Total cost = Unit cost x Units per period x Number of periods</div>
      </div>
    </>
  );
};

export const variableCostInfo = () => {
  return (
    <>
      <div className="info-title">Important notice - Variable cost SKU</div>
      <div className="info-content">
        <div>
          This is a variable SKU with an estimated cost. Actual charges depend
          on your consumption and are billed at the end of each billing cycle
          during active periods.
        </div>
      </div>
    </>
  );
};

export const fixedCostInfo = () => {
  return (
    <>
      <div className="info-title">Fixed cost SKU</div>
      <div className="info-content">
        <div>
          This is a fixed SKU with a standard unit cost. Charges are based on
          the units you select each month (billed the 1st of the following month
          or week billed on the Saturday of the following week).
        </div>
      </div>
    </>
  );
};

export const extensionCostInfo = () => {
  return (
    <>
      <div className="info-title">Extension SKU</div>
      <div className="info-content">
        <div>
          The “Extension” label appears on SKUs that have been extended so you
          can easily identify them.
        </div>
      </div>
    </>
  );
};

export const variableTotalInfo = () => {
  return (
    <>
      <div className="info-title">Important notice - Variable cost</div>
      <div className="info-content">
        <div>
          This shows the estimated total of your variable SKUs. Actual charges
          are based on your consumption and billed at the end of each billing
          cycle during active periods.
        </div>
      </div>
    </>
  );
};
